import Button from 'components/common/Button';
import styled from 'styled-components';
import {device} from '../../styled/device';

export const StyledModalGuestRegistered = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 392px;
  margin: 0 auto;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;

  img {
    width: 54px;
    height: 54px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  .registered-guest-modal__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 30px;
    font-weight: 400;
    color: #23262f;
    padding: 20px;
  }

  @media (max-width: ${device.mobileL}) {
    & .registered-guest-modal__title {
      gap: 0;
    }
  }
`;

export const ModalTitleText = styled.div`
  margin: 0;
  white-space: nowrap;
  font-family: Poppins, sans-serif;
  font-size: 18px;

  @media (max-width: ${device.mobileL}) {
    white-space: normal;
    /* padding-right: 15px; */
  }
`;

export const ModalSubtitle = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #152946;
  width: 258px;
  height: 48px;

  b {
    color: #353945;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 20px;
`;

export const ErrorMessage = styled.div`
  margin-bottom: 64px;
`;
export const CloseButton = styled(Button)`
  margin: 0 auto;
`;
